import { Button, Checkbox, Col, Form, Input, Row, Upload } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { BaseURL } from "../../../constants/enum/baseURL.emum";
import { CourseContext } from "../../../pages/send/doc5/doc5";
import doc5Service from "../../../services/doc5.service";
import scheduleService from "../../../services/schedule.service";
import BtnSendDoc5ListGroup from "./btnSendDoc5ListGroup";
import kpiList from "../../../constants/enum/kpi";

const BtnSendDoc5 = (props: {
  schedule: any;
  curri: any;
  course: any;
  teacher: string;
  doc5: string;
  doc3Id: number;
}) => {
  const { schedule, curri, course, teacher, doc5, doc3Id } = props;
  // console.log(teacher.split(","));
  const user = JSON.parse(localStorage.getItem("user") ?? "false");
  // console.log(curri);

  const { setDoc5List } = useContext<any>(CourseContext);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [sche, setSche] = useState<any>({});
  useEffect(() => {
    (async () => {
      await scheduleService.getById(schedule).then((res: any) => {
        setSche(res.data);
      });
    })();
  }, [schedule]);
  const [kpi, setKpi] = useState<
    {
      id: string;
      value: string;
      name: string;
    }[]
  >([]);
  useEffect(() => {
    // Should not ever set state during rendering, so do this in useEffect instead.
    if (curri.type === "tqf") {
      setKpi(kpiList.kpiTQF);
    } else {
      setKpi(kpiList.kpiMhesi);
    }
  }, [curri.type]);

  const onFinish = async (values: any) => {
    // console.log(values);
    ///////////// รอส่งไปบันทึกหลักบ้าน
    await doc5Service
      .createDoc5({ ...values, doc3Id })
      .then(() => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "บันทึกสำเร็จ",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          doc5Service.getByDoc3(doc3Id).then((res: any) => {
            setDoc5List(res.data);
          });
          handleClose();
          window.location.reload();
        });
      })
      .catch((error) => {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "มีความผิดพลาดบางอย่าง",
          showConfirmButton: false,
          timer: 1500,
        });
      });
  };
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const normFile = (e: any) => {
    // console.log("upload file:", e);
    if (Array.isArray(e)) {
      return e;
    }

    return e && e.fileList;
  };

  const propsUploadDoc5 = {
    naem: "file",

    action: `${BaseURL.BASE_URL}/upload/doc5`,
    onChange: (info: any) => {
      return info;
    },
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-outline-warning text-dark"
        onClick={handleShow}
      >
        <i className="bi bi-pencil-square"></i> ส่ง{" "}
        {curri.type === "tqf" ? "มคอ." : "อชว."}5 | R-2
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        // centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            ส่งเอกสาร {curri.type === "tqf" ? "มคอ." : "อชว."}5 | R-2
            ประจำปีการศึกษา {sche.year} เทอม {sche.term}
          </Modal.Title>
        </Modal.Header>
        <Form
          name="basic"
          // labelCol={{ span: 8 }}
          // wrapperCol={{ span: 16 }}
          initialValues={{
            group: [],
            teacher: [],
            kpi: [],
            sendBy: `${user.firstName} ${user.lastName}`,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="vertical"
        >
          <Modal.Body>
            <div className="row g-3">
              <div className="col-12">
                <h6>
                  หลักสูตร : {curri.name} ({curri.shortName})
                </h6>
                <span>
                  รายวิชา : {course.course.courseCode} วิชา{course.course.name}
                </span>
                <hr />
              </div>
            </div>

            <div>
              <Form.Item
                name="group"
                label="กลุ่มเรียน"
                rules={[
                  {
                    required: true,
                    message: "เลือกกลุ่มเรียนก่อนครับ!",
                  },
                ]}
              >
                <Checkbox.Group style={{ width: "100%" }}>
                  <Row>
                    {doc5.split(",").map((group: any) => {
                      return (
                        <BtnSendDoc5ListGroup
                          key={group}
                          group={group}
                          doc3Id={doc3Id}
                        />
                      );
                    })}
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </div>
            <div>
              {/* <label htmlFor="teacher" className="form-label">
                อาจารย์ผู้สอน
              </label> */}
              <Form.Item
                name="teacher"
                label="อาจารย์ผู้สอน"
                rules={[
                  {
                    required: true,
                    message: "เลือกอาจารย์ผู้สอนอย่างน้อย 1 ท่าน!",
                  },
                ]}
              >
                <Checkbox.Group style={{ width: "100%" }}>
                  <Row>
                    {teacher.split(",").map((teacher: any) => {
                      //ส่งไปหาก่อนว่าจะมีการส่งหรือยัง ถ้าส่งแล้วให้ disabled
                      return (
                        <Col key={teacher} span={12}>
                          <Checkbox value={teacher}>{teacher}</Checkbox>
                        </Col>
                      );
                    })}
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </div>
            <div>
              {/* <Form.Item name="kpi" label="ตรงตาม KPI">
                <Checkbox.Group style={{ width: "100%" }}>
                  <Row>
                    <Col span={12}>
                      <Checkbox value="kpi1">KPI 1</Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="kpi2">KPI 2</Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="kpi3">KPI 3</Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="kpi4">KPI 4</Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Form.Item> */}
              <Row>
                <Col>ตรงกับ KPI</Col>
              </Row>
              <Form.Item name="kpi">
                <Checkbox.Group style={{ width: "100%" }}>
                  {kpi.map((kpi) => {
                    return (
                      <Row key={kpi.id}>
                        <Col>
                          <Checkbox value={kpi.value}>{kpi.name}</Checkbox>
                        </Col>
                      </Row>
                    );
                  })}
                </Checkbox.Group>
              </Form.Item>

              <Form.Item
                name="upload"
                label="ไฟล์เอกสาร มคอ.5"
                valuePropName="fileList"
                getValueFromEvent={normFile}
                rules={[{ required: true, message: "upload เอกสารด้วยครับ!" }]}
              >
                <Upload {...propsUploadDoc5} maxCount={1}>
                  <Button>Click to upload</Button>
                </Upload>
              </Form.Item>
              <p className="text-danger">
                อัพโหลดได้เฉพาะไฟล์ PDF และอัพโหลดได้เพียง 1 ไฟล์เท่านั้น
              </p>

              <div className="col">
                <label htmlFor="sendBy">
                  ผู้ส่งเอกสาร {curri.type === "tqf" ? "มคอ." : "อชว."}5 | R-2
                </label>
                <Form.Item
                  name="sendBy"
                  rules={[
                    { required: true, message: "Please input your username!" },
                  ]}
                >
                  <Input disabled />
                </Form.Item>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit" className="btn btn-primary">
              เพิ่มข้อมูล
            </button>
            <button type="reset" className="btn btn-warning">
              ล้าง
            </button>

            <button
              type="button"
              className="btn btn-danger"
              onClick={handleClose}
            >
              Close
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default BtnSendDoc5;
